export const START_EXPERIMENT = 'START_EXPERIMENT';

export const RECEIVE_NEW_EXPERIMENT_FLAGS = 'RECEIVE_NEW_EXPERIMENT_FLAGS';

export const receiveNewExperimentFlagsAction = ({ flags }) => ({
	type: RECEIVE_NEW_EXPERIMENT_FLAGS,
	payload: flags,
});
